module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2cdfd14a17ab67ccda2e207b07d42672.png";